import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettingsComponent } from "../ProtocolSettingsComponent";
import { SnmpSettings, SnmpVersion } from 'DiscoveryEngine.TS/Protocols';
import { StringUtils, ValueEncoder } from 'DiscoveryEngine.TS/Utils';

@Component({
    selector: 'snmp-settings',
	templateUrl: './snmp-settings.component.html',
	styleUrls: ['./snmp-settings.component.scss']
})
export class SnmpSettingsComponent extends ProtocolSettingsComponent<SnmpSettings> implements OnChanges {

	public Name: UntypedFormControl;
	public ReadCommunity: UntypedFormControl;
	public WriteCommunity: UntypedFormControl;
	public Version: UntypedFormControl;
	public Timeout: UntypedFormControl;
	public Retries: UntypedFormControl;
	public Port: UntypedFormControl;
	public UseGetBulk: UntypedFormControl;
	public DisableReplySourceCheck: UntypedFormControl;
	public BlockIpScope: UntypedFormControl;
	public IsDefault: UntypedFormControl;

	private WriteCommunityChanged: boolean;

	constructor(private fb: UntypedFormBuilder) {
		super();
		this.BuildForm();
	}

	protected BuildForm(): void {
		this.PasswordInputType = "password";

		if (this.Settings) {
			this.Name = new UntypedFormControl(this.Settings.Name, Validators.required);
			this.ReadCommunity = new UntypedFormControl(this.Settings.ReadCommunity, Validators.required);
			this.WriteCommunity = new UntypedFormControl(this.hidePassword(this.Settings.WriteCommunity));
			this.Version = new UntypedFormControl(this.Settings.Version + "", Validators.required);
			this.Timeout = new UntypedFormControl(this.Settings.Timeout, Validators.compose([Validators.required, this.minValue(200), this.maxValue(60000)]));
			this.Retries = new UntypedFormControl(this.Settings.Retries, Validators.compose([Validators.required, this.minValue(0), this.maxValue(10)]));
			this.Port = new UntypedFormControl(this.Settings.Port, Validators.compose([Validators.required, this.minValue(1), this.maxValue(65535)]));
			this.UseGetBulk = new UntypedFormControl(this.Settings.UseGetBulk);
			this.DisableReplySourceCheck = new UntypedFormControl(this.Settings.DisableReplySourceCheck);

			this.ShowChars = new UntypedFormControl(false);
			this.BlockIpScope = new UntypedFormControl(this.Settings.BlockIpScope.ToString());
			this.IsDefault = new UntypedFormControl(this.Settings.IsDefault);
			
			this.enableDisableControls();

			this.WriteCommunityChanged = false;

			this.SettingsForm = this.fb.group({
				Name: this.Name,
				ReadCommunity: this.ReadCommunity,
				WriteCommunity: this.WriteCommunity,
				Version: this.Version,
				Timeout: this.Timeout,
				Retries: this.Retries,
				Port: this.Port,
				UseGetBulk: this.UseGetBulk,
				DisableReplySourceCheck: this.DisableReplySourceCheck,
				ShowChars: this.ShowChars,
				BlockIpScope: this.BlockIpScope,
				IsDefault: this.IsDefault,
			});
		}
		else {
			this.SettingsForm = null;
			this.Name = null;
			this.ReadCommunity = null;
			this.WriteCommunity = null;
			this.Version = null;
			this.Timeout = null;
			this.Retries = null;
			this.Port = null;
			this.UseGetBulk = null;
			this.DisableReplySourceCheck = null;
			this.ShowChars = null;
			this.BlockIpScope = null;
			this.IsDefault = null;
		}
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.ShowChars, this.AllowShowChars);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public get invalidTempChanges(): string[] {
		return ["SNMP Communities"];
	}

	public applyTempChanges(): void {
		this.Settings.Name = this.Name.value;
		this.Settings.ReadCommunity = this.ReadCommunity.value;
		if (this.WriteCommunityChanged) {
			this.Settings.WriteCommunity = StringUtils.ObfuscateString2(this.WriteCommunity.value);
		}
		this.Settings.Version = parseInt(this.Version.value);
		this.Settings.Timeout = parseInt(this.Timeout.value);
		this.Settings.Retries = parseInt(this.Retries.value);
		this.Settings.Port = parseInt(this.Port.value);
		this.Settings.UseGetBulk = this.UseGetBulk.value;
		this.Settings.DisableReplySourceCheck = this.DisableReplySourceCheck.value;
		this.Settings.BlockIpScope.FromString(this.BlockIpScope.value);
		this.Settings.IsDefault = this.IsDefault.value;

		this.BuildForm();
		this.OnApplyTempChanges();
	}

}
